import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAppSession } from "../../state/AppSessionContext.jsx";

export default function Login() {
  const { signIn, isSignedIn } = useAppSession();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const tried = useRef(false);

  useEffect(() => {
    if (isSignedIn) navigate("/", { replace: true });
  }, [isSignedIn, navigate]);

  useEffect(() => {
    if (tried.current) return;
    tried.current = true;

    const code = window.location.hash.replace(/^#/, "").trim();
    if (!code) return;

    setBusy(true);
    window.history.replaceState(null, "", window.location.pathname);

    signIn(code).then(
      () => navigate("/", { replace: true }),
      (err) => {
        setError(err.message);
        setBusy(false);
      },
    );
  }, [signIn, navigate]);

  return (
    <div className="gate">
      <div className="gate-card">
        <div className="gate-mark">R</div>
        <h1>Rasmalai</h1>

        {busy && <p className="gate-sub">Signing you in…</p>}

        {!busy && error && (
          <>
            <div className="gate-error">{error}</div>
            <p className="gate-hint">
              Send <code>/login</code> to the bot on Telegram for a fresh link. Links last 10 minutes.
            </p>
          </>
        )}

        {!busy && !error && (
          <>
            <p className="gate-sub">Your dashboard opens from Telegram.</p>
            <p className="gate-hint">
              Send <code>/login</code> to the Rasmalai bot and tap the link it sends back. No password,
              nothing to remember — the link expires in 10 minutes.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
